module.exports = __webpack_public_path__ + "static/media/Mastercard.7c4454ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/makseKeskus/Mastercard.png
// module id = 162
// module chunks = 15